:host {
  @apply block;
}

::slotted([slot=copy-above]) {
  @apply my-6;
}

::slotted([slot=copy-below]) {
  @apply my-6;
}

::slotted([slot=media]) {
  @apply my-6;
}
